export default __webpack_public_path__ + "static/media/RTP3.e729727a.webp";